<template>
  <div>
    <Loading :value="loading"></Loading>
    <v-dialog
      v-model="dialogContrat"
      :persistent="true"
      fullscreen
      transition="dialog-bottom-transition"
      scrollable
    >
      <v-card tile>
        <v-toolbar card dark color="primary">
          <v-toolbar-title
            >FICHE DU PRESTATAIRE/OUVRIER {{ libPrestataire }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click.native="closeDialog()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-layout row class="mb-5 mt-2 elevation-3 pt-4 pl-2 pr-2 pb-4">
            <v-flex xs1 class="text-xs-left mr-3 ">
              <v-avatar
                :tile="true"
                size="140px"
                height="140px"
                color="grey lighten-4"
              >
                <img :src="infoPrestataire.url" alt="avatar" />
              </v-avatar>
            </v-flex>

            <!--Information personnelles-->
            <v-flex xs7 class="mr-2 ml-2">
              <v-layout wrap>
                <v-flex xs12>
                  <h4 mt-2>INFORMATION PERSONNELLE</h4>
                  <v-divider class="mb-3"></v-divider>
                </v-flex>
                <v-flex xs12>
                  <v-layout row>
                    <v-flex xs6 class="mr-4">
                      <!--COLONNE 1-->

                      <v-layout wrap>
                        <v-flex xs12>
                          <v-layout row>
                            <v-flex xs6>Nom</v-flex>
                            <v-flex xs6 class="text-xs-right title">
                              {{ infoPrestataire.nom }}
                            </v-flex>
                          </v-layout>
                          <v-divider class="mb-3"></v-divider>

                          <v-layout row>
                            <v-flex xs6>Domicile/Siege</v-flex>
                            <v-flex xs6 class="text-xs-right title">
                              {{ infoPrestataire.domicile }}
                            </v-flex>
                          </v-layout>
                          <v-divider class="mb-3"></v-divider>

                          <v-layout row>
                            <v-flex xs6>Contact</v-flex>
                            <v-flex xs6 class="text-xs-right title">
                              {{ infoPrestataire.contact }}
                            </v-flex>
                          </v-layout>
                          <v-divider class="mb-3"></v-divider>

                          <v-layout row>
                            <v-flex xs6>Profession</v-flex>
                            <v-flex xs6 class="text-xs-right title">
                              {{ infoPrestataire.profession }}
                            </v-flex>
                          </v-layout>
                          <v-divider class="mb-3"></v-divider>
                        </v-flex>
                      </v-layout>
                    </v-flex>

                    <v-flex xs6>
                      <!--COLONNE 2-->
                      <v-layout row>
                        <v-flex xs6>Type pièce</v-flex>
                        <v-flex xs6 class="text-xs-right title">
                          {{ infoPrestataire.piece }}
                        </v-flex>
                      </v-layout>
                      <v-divider class="mb-3"></v-divider>

                      <v-layout row>
                        <v-flex xs6>Numéro ID</v-flex>
                        <v-flex xs6 class="text-xs-right title">
                          {{ infoPrestataire.numPiece }}
                        </v-flex>
                      </v-layout>
                      <v-divider class="mb-3"></v-divider>

                      <v-layout row>
                        <v-flex xs6>Date de naissance</v-flex>
                        <v-flex xs6 class="text-xs-right title">
                          {{ infoPrestataire.dateNaiss }}
                        </v-flex>
                      </v-layout>
                      <v-divider class="mb-3"></v-divider>

                      <v-layout row>
                        <v-flex xs4>Enregistré le</v-flex>
                        <v-flex xs8 class="text-xs-right title">
                          {{ infoPrestataire.created }}
                        </v-flex>
                      </v-layout>
                      <v-divider class="mb-3"></v-divider>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
            <!--Information personnelles-->

            <v-flex xs5 class="text-xs-center ml-3 ">
              <!--Diagramme du montant  total a verser/ montant verse-->
              <!--Diagramme representant les jours de presence et absence-->
              <div
                class="elevation-3"
                id="statMontVerse"
                style="width:100%; height: 300px"
              ></div>
            </v-flex>
          </v-layout>

          <v-layout row class="mb-4">
            <v-flex xs12 style="width:100%;">
              <h4 mt-2>LISTE DES CONTRATS</h4>
              <v-divider class="mb-2"></v-divider>
              <v-layout row>
                <v-flex class="mb-1" xs12 md4>
                  <v-card-text class="text-xs-center">
                    <v-chip
                      label
                      outline
                      color="primary darken-1"
                      class="elevation-4"
                      style="width:100%"
                    >
                      <span class="subheading">Total : </span>
                      <span class="title"
                        >&nbsp
                        {{ new Intl.NumberFormat().format(montantTotal) }}
                      </span>
                    </v-chip>
                  </v-card-text>
                </v-flex>

                <v-flex class="mb-1" xs12 md4>
                  <v-card-text class="text-xs-center">
                    <v-chip
                      label
                      outline
                      color="green darken-1"
                      class="elevation-4"
                      style="width:100%"
                    >
                      <span class="subheading">Total payé: </span>
                      <span class="title"
                        >&nbsp
                        {{ new Intl.NumberFormat().format(montantTotalVerse) }}
                      </span>
                    </v-chip>
                  </v-card-text>
                </v-flex>

                <v-flex class="mb-1" xs12 md4>
                  <v-card-text class="text-xs-center">
                    <v-chip
                      label
                      outline
                      color="orange darken-1"
                      class="elevation-4"
                      style="width:100%"
                    >
                      <span class="subheading">Total restant: </span>
                      <span class="title"
                        >&nbsp
                        {{
                          new Intl.NumberFormat().format(montantTotalRestant)
                        }}
                      </span>
                    </v-chip>
                  </v-card-text>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <!--LISTE CONTRAT OUVRIER-->
                <v-flex xs12 class="elevation-3 pt-3 pl-3 pr-3 pb-3">
                  <h4>PRESTATION TACHES</h4>
                  <v-divider class="mb-2"></v-divider>
                  <data-tables :data="listeContratsTache" style="width:99%;">
                    <el-table-column
                      prop="idContrat"
                      label="ID-CONTRAT"
                      align="center"
                    ></el-table-column>
                    <el-table-column
                      prop="etatContrat"
                      label="ETAT CONTRAT"
                      align="center"
                    >
                      <template slot-scope="scope">
                        <el-tag
                          v-if="scope.row.etat == 0"
                          class="subheading"
                          type="info"
                        >
                          {{ scope.row.etatContrat }}
                        </el-tag>
                        <el-tag v-if="scope.row.etat == 1" class="subheading">
                          {{ scope.row.etatContrat }}
                        </el-tag>
                        <el-tag
                          v-if="scope.row.etat == 2"
                          class="subheading"
                          type="blue"
                        >
                          {{ scope.row.etatContrat }}
                        </el-tag>
                        <el-tag
                          v-if="scope.row.etat == 3"
                          class="subheading"
                          type="success"
                        >
                          {{ scope.row.etatContrat }}
                        </el-tag>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="tache"
                      label="TACHE"
                      align="center"
                    ></el-table-column>
                    <el-table-column
                      prop="dateDbtFin"
                      label="PERIODE"
                    ></el-table-column>
                    <el-table-column
                      prop="dureePresence"
                      label="PRESENCE(H)/EVOLUTION(%)"
                      align="center"
                    ></el-table-column>
                    <el-table-column
                      prop="montantContrat"
                      label="MONTANT/OUVRIER(HRE)"
                      align="center"
                    >
                      <template slot-scope="scope">
                        <el-tag type="info">
                          {{ scope.row.montantContrat }}
                        </el-tag>
                      </template>
                    </el-table-column>

                    <el-table-column
                      prop="montantTotalFormat"
                      label="MONTANT TOTAL"
                      align="center"
                    >
                      <template slot-scope="scope">
                        <el-tag>
                          {{ scope.row.montantTotalFormat }}
                        </el-tag>
                      </template>
                    </el-table-column>

                    <el-table-column
                      prop="mntAverserContrat"
                      label="MONTANT A PAYER"
                      align="center"
                    >
                      <template slot-scope="scope">
                        <el-tag type="success">
                          {{
                            new Intl.NumberFormat().format(
                              scope.row.mntAverserContrat
                            )
                          }}
                        </el-tag>
                      </template>
                    </el-table-column>

                    <el-table-column
                      prop="mntVerseFormat"
                      label="MONTANT PAYE"
                      align="center"
                    >
                      <template slot-scope="scope">
                        <el-tag type="success">
                          {{ scope.row.mntVerseFormat }}
                        </el-tag>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="mntRestantFormat"
                      label="MONTANT RESTANT"
                      align="center"
                    >
                      <template slot-scope="scope">
                        <el-tag type="warning">
                          {{ scope.row.mntRestantFormat }}
                        </el-tag>
                      </template>
                    </el-table-column>

                    <el-table-column label="ACTION">
                      <template slot-scope="scope">
                        <v-tooltip top>
                          <v-btn
                            :disabled="
                              scope.row.montantTotalFormat == 0 ||
                                scope.row.mntRestantFormat == 0
                            "
                            slot="activator"
                            fab
                            small
                            color="green"
                            @click.native.prevent="
                              showDialogPaiement(scope.row)
                            "
                            dark
                          >
                            <v-icon center>local_atm</v-icon>
                          </v-btn>
                          Notifier un paiement
                        </v-tooltip>
                      </template>
                    </el-table-column>
                  </data-tables>
                </v-flex>

                <!--LISTE CONTRAT PRESTATAIRE-->
                <v-flex
                  xs12
                  v-if="type == 1"
                  class="elevation-3 mt-4 pt-3 pl-3 pr-3 pb-3"
                >
                  <h4>PRESTATION TRAVAUX/CHANTIERS</h4>
                  <v-divider class="mb-2"></v-divider>
                  <data-tables :data="listeContratsTravaux" style="width:99%;">
                    <el-table-column
                      prop="idContrat"
                      label="ID-CONTRAT"
                      align="center"
                    ></el-table-column>

                    <el-table-column
                      prop="etatContrat"
                      label="ETAT CONTRAT"
                      align="center"
                    >
                      <template slot-scope="scope">
                        <el-tag
                          v-if="scope.row.etat == 0"
                          class="subheading"
                          type="info"
                        >
                          {{ scope.row.etatContrat }}
                        </el-tag>
                        <el-tag v-if="scope.row.etat == 1" class="subheading">
                          {{ scope.row.etatContrat }}
                        </el-tag>
                        <el-tag
                          v-if="scope.row.etat == 2"
                          class="subheading"
                          type="blue"
                        >
                          {{ scope.row.etatContrat }}
                        </el-tag>
                        <el-tag
                          v-if="scope.row.etat == 3"
                          class="subheading"
                          type="success"
                        >
                          {{ scope.row.etatContrat }}
                        </el-tag>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="type"
                      label="TYPE"
                      align="center"
                    ></el-table-column>
                    <el-table-column
                      prop="tache"
                      label="TRAVAUX/CHANTIER"
                      align="center"
                    ></el-table-column>
                    <el-table-column label="EVOLUTION" align="center">
                      <template slot-scope="scope">
                        <v-progress-circular
                          :size="80"
                          :width="15"
                          :rotate="360"
                          :value="scope.row.evolution"
                          color="orange"
                        >
                          {{ scope.row.evolutionNbr }} %
                        </v-progress-circular>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="montantContrat"
                      label="MONTANT CONTRAT"
                      align="center"
                    >
                      <template slot-scope="scope">
                        <el-tag>
                          {{
                            new Intl.NumberFormat().format(
                              scope.row.montantContrat
                            )
                          }}
                        </el-tag>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="mntVerserContrat"
                      label="MONTANT PAYE"
                      align="center"
                    >
                      <template slot-scope="scope">
                        <el-tag type="success">
                          {{
                            new Intl.NumberFormat().format(
                              scope.row.mntVerserContrat
                            )
                          }}
                        </el-tag>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="mntAverserContrat"
                      label="MONTANT A PAYE"
                      align="center"
                    >
                      <template slot-scope="scope">
                        <el-tag type="warning">
                          {{
                            new Intl.NumberFormat().format(
                              scope.row.mntAverserContrat
                            )
                          }}
                        </el-tag>
                      </template>
                    </el-table-column>
                  </data-tables>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>

          <v-layout row>
            <!--Historique des paiements-->
            <v-flex xs6 class="elevation-3  pt-3 pl-3 pr-3 pb-3">
              <v-layout wrap>
                <v-flex xs12>
                  <h4 mt-2>HISTORIQUE DES PAIEMENTS</h4>
                  <v-divider class="mb-3"></v-divider>
                </v-flex>
                <v-flex xs12 class="text-xs-right">
                  <v-tooltip top>
                    <v-btn
                      v-if="true"
                      slot="activator"
                      color="orange"
                      :disabled="false"
                      @click.stop="imprimePaiementPDF()"
                      dark
                    >
                      Imprimer
                      <v-icon right>print</v-icon> </v-btn
                    >Imprimer les paiements
                  </v-tooltip>
                </v-flex>

                <v-flex xs12>
                  <data-tables :data="listePaiements" style="width:99%;">
                    <el-table-column
                      prop="idContrat"
                      label="ID-CONTRAT"
                      align="center"
                    ></el-table-column>
                    <el-table-column
                      prop="libelleFact"
                      label="FACTURE"
                      align="center"
                    ></el-table-column>
                    <el-table-column
                      prop="libelleTrx"
                      label="TRAVAUX"
                      align="center"
                    ></el-table-column>
                    <el-table-column prop="mnt" label="MONTANT" align="center">
                      <template slot-scope="scope">
                        <el-tag type="info">
                          {{ scope.row.mnt }}
                        </el-tag>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="auteur"
                      label="AUTEUR"
                      align="center"
                    ></el-table-column>
                    <el-table-column
                      prop="datePaiement"
                      label="DATE DE PAIEMENT"
                      align="center"
                    ></el-table-column>
                    <el-table-column
                      label="Actions"
                      width="140"
                      fixed="right"
                      v-if="this.type == 0"
                    >
                      <template slot-scope="scope">
                        <v-btn
                          icons
                          color="orange"
                          @click="imprimerFacture(scope.row)"
                          fab
                          dark
                          small
                        >
                          <v-icon>print</v-icon>
                        </v-btn>
                      </template>
                    </el-table-column>
                  </data-tables>
                </v-flex>
              </v-layout>
            </v-flex>

            <!--Liste de presence-->
            <v-flex
              xs6
              class="ml-4 elevation-3  pt-3 pl-3 pr-3 pb-3"
              v-if="type == 0"
            >
              <h4 mt-2>LISTE DE PRESENCE</h4>
              <v-divider class="mb-2"></v-divider>
              <v-layout row>
                <v-flex xs12>
                  <data-tables
                    :data="tablePresence"
                    :header-row-style="headerRowStyle"
                    highlight-current-row
                    :summary-method="getSummExploitBudget"
                    show-summary
                    style="width: 100%"
                  >
                    <el-table-column
                      prop="tache"
                      label="TRAVAUX/TACHE"
                      sortable
                    >
                      <template slot-scope="scope">{{
                        scope.row.tache
                      }}</template>
                    </el-table-column>
                    <el-table-column
                      prop="datePresence"
                      label="Date PRESENCE"
                    ></el-table-column>
                    <el-table-column
                      prop="duree"
                      label="DUREE"
                    ></el-table-column>
                    <el-table-column
                      prop="mntHeur"
                      label="MONTANT/HRE"
                      sortable
                    >
                      <template slot-scope="scope">
                        <el-tag type="info">
                          {{ scope.row.mntHeur }}
                        </el-tag>
                      </template>
                    </el-table-column>
                    <el-table-column prop="mntJour" label="TOTAL">
                      <template slot-scope="scope">
                        <el-tag>
                          {{ scope.row.mntJour }}
                        </el-tag>
                      </template>
                    </el-table-column>
                  </data-tables>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>

          <br />
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- MODAL NOTIFIER PAIEMENT -->

    <v-dialog v-model="dialogPaiement" max-width="700" :persistent="true">
      <v-card tile>
        <v-toolbar card dark color="primary">
          <v-toolbar-title
            >Enregistrer un paiement. contrat-{{ idContrat }}</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-btn icon dark @click.native="dialogPaiement = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <el-form
            label-position="top"
            id="formPaiement"
            :model="formPaiement"
            ref="formPaiement"
            :inline="true"
            class="demo-form-inline"
          >
            <el-form-item label="Montant" style="width:50%">
              <el-input-number
                style="width:80%"
                v-model="formPaiement.montant"
                :min="5"
                :max="mntMaxRestant"
              ></el-input-number>
            </el-form-item>

            <el-form-item label="Date de paiement" required style="width:40%">
              <el-date-picker
                style="width:100%"
                type="date"
                placeholder="Choisir une date de paiement"
                format="dd-MM-yyyy"
                value-format="yyyy-MM-dd"
                v-model="formPaiement.datePaiement"
              ></el-date-picker>
            </el-form-item>
          </el-form>
          <div class="text-xs-right">
            <v-btn color="grey" @click="resetForm('formPaiement')" dark>
              Annuler
              <v-icon right>remove_circle</v-icon>
            </v-btn>
            <v-btn
              icons
              dark
              color="green"
              @click="submitFormPaiement('formPaiement')"
            >
              Enregistrer
              <v-icon right>add</v-icon>
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- MODAL NOTIFIER PAIEMENT -->
  </div>
</template>

<script>
var echarts = require("echarts/lib/echarts");
require("echarts/lib/chart/bar");
require("echarts/lib/chart/pictorialBar");
require("echarts/lib/chart/funnel");
require("echarts/lib/chart/sankey");
require("echarts/lib/chart/scatter");
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");
import html2canvas from "html2canvas";

import Loading from "@/components/Loading";
export default {
  components: { Loading },
  name: "Contrat_ouvrier",
  props: {
    show: {
      type: Boolean
    },
    type: {
      type: Number, //0=>ouvrier 1=> prestataire
      default: 0
    },
    idPrestataire: {
      type: Number
    },
    idChant: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      //data general
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      loading: false,

      dialogContrat: false,
      libPrestataire: "",
      listeContratsTache: [],
      listeContratsTravaux: [],
      tablePresence: [],
      infoPrestataire: {},
      listePaiements: [],
      dialogPaiement: false,
      formPaiement: {
        montant: 5
      },
      idContrat: null,
      montantTotalVerse: 0,
      montantTotalRestant: 0,
      montantTotal: 0,
      mntMaxRestant: 0
    };
  },

  watch: {
    show: function(newValue, oldvalue) {
      this.dialogContrat = newValue;
      if (newValue == true) {
        this.loadHistorique();
        this.montantTotalVerse = 0;
        this.montantTotalRestant = 0;
        this.montantTotal = 0;

        if (this.type == 0) {
          // ouvrier
          this.loadContratOuvrier(this.idPrestataire);
          this.loadPresence();
          this.loadInfOuvrier();
        } // prestataire
        else {
          this.loadInfPrestataire();
          this.loadContratTacheFournisseur(this.idPrestataire);
          this.loadContratTrxFournisseur(this.idPrestataire);
        }
      }
    }
  },

  methods: {
    //statistique etat
    statistiqueMntVerse() {
      let option = {
        backgroundColor: "#fafafa",
        title: {
          text: "STATISTIQUE MONTANT PAYE/RESTANT",
          subtext: "",
          x: "center"
        },
        tooltip: {
          trigger: "item",
          formatter: "{b} : {c} ({d}%)"
        },

        series: [
          {
            name: "",
            type: "pie",
            radius: "70%",
            center: ["50%", "50%"],

            data: [
              {
                value: this.montantTotalRestant,
                name: "mnt restant",
                itemStyle: {
                  color: "#c23531"
                }
              },
              {
                value: this.montantTotalVerse,
                name: "mnt verse",
                itemStyle: {
                  color: "#22c22a"
                }
              }
            ],
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }
        ]
      };
      let geneChartStatMontVerse = echarts.init(
        document.getElementById("statMontVerse")
      );
      geneChartStatMontVerse.setOption(option);
    },

    headerRowStyle({ row, rowIndex }) {
      return { color: "black" };
    },
    getSummExploitBudget(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Sous total";
          return;
        }

        if (index === 3) {
          sums[index] = "N/A";
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = new Intl.NumberFormat().format(
            values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0)
          );
        } else {
          sums[index] = "N/A";
        }
      });

      return sums;
    },

    loadContratOuvrier(idOuvrier) {
      this.loading = true;
      this.listeContratsTache.splice(0);
      let url =
        this.domaine +
        "contrat/prestataire/ouvrier/" +
        idOuvrier +
        "/chantier/" +
        this.idChant;
      this.$http.get(url).then(
        response => {
          this.libPrestataire = response.body.libPrestataire;
          this.listeContratsTache = response.body.contrats;
          this.montantTotalVerse = response.body.mntTotalVerse;
          this.montantTotalRestant = response.body.mntTotalRestant;
          this.montantTotal = response.body.mntTotal;
          this.loading = false;
          this.statistiqueMntVerse();
        },
        error => {
          this.loading = false;
          this.$message.error("Echec lors du chargement des contrats ouvriers");
        }
      );
    },
    imprimePaiementPDF() {
      let url = "";
      if (this.type == 0) {
        // ouvrier
        url =
          this.domaine +
          "ouvrier/" +
          this.idPrestataire +
          "/imprimer_paiement/" +
          this.idChant +
          "/" +
          this.user.id;
        window.open(url);
      } // prestataire
      else {
        url =
          this.domaine +
          "ouvrier/" +
          this.idPrestataire +
          "/imprimer_paiement_presataire/" +
          this.idChant +
          "/" +
          this.user.id;
        window.open(url);
      }
    },
    imprimerFacture(ligne) {
      let url = "";
      url =
        this.domaine +
        "ouvrier/" +
        this.idPrestataire +
        "/imprimer/recu/" +
        this.idChant +
        "/" +
        this.user.id;
      window.open(url);
    },

    loadContratTacheFournisseur(idFournisseur) {
      this.loading = true;
      this.listeContratsTache.splice(0);
      let url =
        this.domaine +
        "contrat/prestataire/fournisseur_tache/" +
        idFournisseur +
        "/chantier/" +
        this.idChant;
      this.$http.get(url).then(
        response => {
          this.libPrestataire = response.body.libPrestataire;
          this.listeContratsTache = response.body.contrats;
          this.montantTotalVerse += response.body.mntTotalVerse;
          this.montantTotalRestant += response.body.mntTotalRestant;
          this.montantTotal += response.body.mntTotal;
          this.loading = false;
          this.statistiqueMntVerse();
        },
        error => {
          this.loading = false;
          this.$message.error("Echec lors du chargement des contrats ouvriers");
        }
      );
    },
    loadPresence() {
      this.loading = true;
      this.tablePresence.splice(0);
      let url = "";

      if (this.type == 0 && this.idChant != null) {
        //ouvrier
        url =
          this.domaine +
          "contrat/prestataire/presence/" +
          this.idPrestataire +
          "/" +
          this.idChant;
      } else {
        return;
      }
      // else if(this.type == 1)//preatataire
      // {
      //     url = this.domaine + "contrat/prestataire/entreprise/" +this.idPrestataire;
      // }

      this.$http.get(url).then(
        response => {
          this.tablePresence = response.body.listePresence;
          this.loading = false;
        },
        error => {
          this.loading = false;
          this.$message.error("Echec lors du chargement des contrats ouvriers");
        }
      );
    },

    loadContratTrxFournisseur(idPrest) {
      this.loading = true;
      this.listeContratsTravaux.splice(0);
      let url =
        this.domaine +
        "contrat/prestataire/fournisseur/travaux/" +
        idPrest +
        "/chantier/" +
        this.idChant;
      this.$http.get(url).then(
        response => {
          this.libPrestataire = response.body.libPrestataire;
          this.listeContratsTravaux = response.body.contrats;
          this.loading = false;
          this.montantTotalVerse += response.body.mntTotalVerse;
          this.montantTotalRestant += response.body.mntTotalRestant;
          this.montantTotal += response.body.mntTotal;
          this.statistiqueMntVerse();
        },
        error => {
          this.loading = false;
          this.$message.error("Echec lors du chargement des contrats ouvriers");
        }
      );
    },
    loadInfOuvrier() {
      this.loading = true;
      let url = this.domaine + "ouvrier/" + this.idPrestataire;
      this.$http.get(url).then(
        response => {
          this.infoPrestataire = response.body.ouvrier;
          this.loading = false;
        },
        error => {
          this.loading = false;
          this.$message.error(
            "Echec lors du chargement des infos du prestataire"
          );
        }
      );
    },
    loadInfPrestataire() {
      this.loading = true;
      let url = this.domaine + "ouvrier/prestataire/" + this.idPrestataire;
      this.$http.get(url).then(
        response => {
          this.infoPrestataire = response.body.prestataire;
          this.loading = false;
        },
        error => {
          this.loading = false;
          this.$message.error(
            "Echec lors du chargement des infos du prestataire"
          );
        }
      );
    },
    closeDialog() {
      this.$emit("close");
    },

    //paiement ouvrier
    submitFormPaiement(formName) {
      if (
        this.formPaiement.montant != "undefined" &&
        this.formPaiement.montant != null
      ) {
        this.loading = true;
        let url =
          this.domaine +
          "ouvrier/" +
          this.idPrestataire +
          "/paiement/contrat/" +
          this.idContrat;
        let data = new FormData();

        data.append("idUser", this.user.id);
        data.append("montant", this.formPaiement.montant);
        data.append("datePaiement", this.formPaiement.datePaiement);

        this.$http.post(url, data).then(
          response => {
            //reinitialiser le formulaire
            this.loading = false;
            this.dialogPaiement = false;
            this.formPaiement.montant = "";
            this.formPaiement.datePaiement = "";

            //recharger l'historique des paiement
            this.loadContratOuvrier(this.idPrestataire);
            this.loadHistorique();

            this.$notify({
              title: "ENREGISTREMENT REUSSI",
              message: "Le paiement a été enregistré",
              type: "success",
              position: "top-center"
            });
          },
          erreur => {
            //reinitialiser le formulaire
            this.loading = false;
            this.$message.error("L'opération a echouée");
          }
        );
      } else {
        this.$message.error("Veuillez remplir correctement les champs svp...");
      }
    },

    showDialogPaiement(contrat) {
      if (this.type == 1) {
        this.$alert(
          "Veuillez effectuer le règlement dans le compte fournissuer",
          "Règlement fournisseur",
          {
            confirmButtonText: "OK",
            callback: action => {
              return;
            }
          }
        );
        return;
      }
      this.idContrat = contrat.idContrat;
      this.dialogPaiement = true;
      this.mntMaxRestant = contrat.mntRestant;
    },

    //Charger l'historique de transaction
    loadHistorique() {
      this.listePaiements.splice(0);
      this.loading = true;
      let url = "";
      if (this.type == 0) {
        url =
          this.domaine +
          "ouvrier/" +
          this.idPrestataire +
          "/historique_paiement_ouvrier_chantier/" +
          this.idChant;
      } else if (this.type == 1) {
        url =
          this.domaine +
          "ouvrier/" +
          this.idPrestataire +
          "/historique_paiement_prestataire/chantier/" +
          this.idChant;
      }

      this.$http.get(url).then(
        response => {
          this.loading = false;
          this.listePaiements = response.body.paiements;
        },
        error => {
          this.loading = false;
          this.$message.error(
            "Une erreur est survenue lors du chargement de l'historique des paiements"
          );
        }
      );
    }
  },

  mounted() {}
};
</script>



// WEBPACK FOOTER //
// src/components/boardChantier/Contrat_ouvrier.vue